import Vue from "vue";
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'
import '@/styles/main.scss'
import '@/styles/mdbvue/scss/mdb.scss'
import '@fortawesome/fontawesome-free/css/all.min.css'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import locales from '@/locales/text';



Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

Vue.prototype.$locales = locales;
Vue.prototype.$currentLang = {value: "de"};

import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueVirtualScroller from 'vue-virtual-scroller'
Vue.use(VueVirtualScroller)

Vue.use(VueLodash, { name: 'custom' , lodash: lodash })

import * as mdbvue from 'mdbvue'
for (const component in mdbvue) {
  Vue.component(component, mdbvue[component])
}
import { dateFilter } from "vue-date-fns";

Vue.filter("date", dateFilter);

import "./plugins/axios";


import router from "./router";
import store from "./store";
import Notify from 'mdbvue/lib/components/Notify'
import VueSession from "vue-session/index.esm";

import App from "./App.vue";
import i18n from './i18n'

Vue.use(Notify)
Vue.use(VueSession, {persist: true})

import {func} from './plugins/DateFormater'
import vuetify from '@/plugins/vuetify'

Vue.prototype.$func = func

export const bus = new Vue();


// mdb access Tooken: BTfp9zs2EjTXpGJrJSzy


Vue.config.productionTip = false;
Vue.use(require('vue-moment'));

let app = new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
global.vm = app;
